import { InputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { FormEvent, InvalidEvent, JSX, useState } from "react";
import { useAssociatedFieldId } from "../../../common/utils/useAssociatedFieldId";

interface Props {
    id: number;
    type: string;
    disabled?: boolean;
    value?: string;
    onChange?: (value: string) => void;
    onInput?: (event: FormEvent<HTMLInputElement>) => void;
    required?: boolean;
    title?: string;
    errorMessage?: string;
    showOptional?: boolean;
}

export const InputFieldComponent = (props: Props): JSX.Element => {
    const {
        id,
        value,
        onChange,
        type,
        disabled,
        required,
        title,
        onInput,
        errorMessage,
        showOptional = true,
    } = props;

    const [inputError, setInputError] = useState<{
        [key: string]: string | null;
    }>({});
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-edit-employee-modal__form-group"}>
            <div className={"c-edit-employee-modal__form-group__optional"}>
                {title && <label htmlFor={fieldId}>{title}</label>}
                {!required && showOptional && <p>optioneel</p>}
            </div>
            <div ref={fieldRef}>
                <InputField
                    onChange={(event: string) => {
                        setInputError((prevErrors) => ({
                            ...prevErrors,
                            [id]: null,
                        }));

                        if (onChange) {
                            onChange(event);
                        }
                    }}
                    required={required}
                    value={value}
                    type={type}
                    disabled={disabled}
                    onInput={onInput}
                    onInvalid={(event: InvalidEvent<HTMLInputElement>) => {
                        event.preventDefault();

                        if (
                            (event.target as HTMLInputElement).validity
                                .valueMissing
                        ) {
                            setInputError((prevErrors) => ({
                                ...prevErrors,
                                [id]: errorMessage,
                            }));
                        }

                        if (
                            (event.target as HTMLInputElement).validity
                                .typeMismatch
                        ) {
                            setInputError((prevErrors) => ({
                                ...prevErrors,
                                [id]: "Ongeldig formaat",
                            }));
                        }
                    }}
                />
            </div>
            {inputError[id] && (
                <p className={"c-error-message"}>{inputError[id]}</p>
            )}
        </div>
    );
};
